export default {
  chooseFile: "Seleccione un archivo",
  browse: "Examinar",
  clearFile: "Eliminar el archivo",
  color: {
    hexValue: "Valor hexadecimal del color",
    presets: "Colores predefinidos",
    noColor: "Ningún color seleccionado",
    picker: "Selector de color",
    open: "Abrir el selector de color",
    saturation: "Saturación y luminosidad",
    saturationValue: "Saturación {saturation} %, luminosidad {value} %",
    hue: "Tono",
    red: "Rojo (0 a 255)",
    green: "Verde (0 a 255)",
    blue: "Azul (0 a 255)",
  },
  icon: {
    list: "Lista de iconos",
    selected: "Icono seleccionado",
    invalid: "Seleccione un icono FontAwesome válido (light)",
    library: "Encuentre la biblioteca de iconos FontAwesome",
  },
  choiceGrid: {
    search: "Buscar...",
    showAll: "Mostrar todo",
    collapse: "Reducir",
    remove: "Quitar {name}",
  },
  empty_icon: "Introduzca un nombre de icono (p. ej. check)",
  info: "Información",
  requiredField: "El campo es obligatorio",
  at_least_one_field_required: "Debe marcar al menos una opción en esta línea.",
  requiredNumberOrFloat: "Introduzca una cifra entera o decimal",
  emailError: "Introduzca un correo electrónico conforme",
  phoneError: "Introduzca un número de teléfono conforme",
  lastName: "Apellido",
  firstName: "Nombre",
  email: "Correo electrónico",
  address: "Dirección",
  complement: "Complemento",
  postCode: "Código postal",
  city: "Ciudad",
  phone: "Teléfono",
  mobile: "Móvil",
  function: "Función",
  actions: "Acciones",
  rights: "Derechos",
  send: "Enviar",
  errors: "Se han detectado errores",
  form_validation: "Los campos siguientes son obligatorios:",
  entitled: "Título",
  title: "Título",
  selectValue: "Seleccionar un valor",
  uploaded_on: "Publicado el",
  error_file: "Parece que el archivo no está disponible",
  no_skill_error_file: "Esta importación de competencias está vacía",
  download_success: "Archivo descargado correctamente",
  file_downloading: "Descarga en curso...",
  download_file: "Descargar el archivo",
  remove_file: "Eliminar el archivo",
  image_preview: "Vista previa de la imagen añadida",
  signed_error: "Vaya, se ha producido un error en el almacenamiento",
  signed_success: "Los cambios han sido guardados correctamente",
  saving: "Almacenamiento en curso",
  confirm: "Confirmar",
  apply: "Aplicar",
  generate: "Generar",
  import: "Importar",
  error_nofile: "Debe añadir un archivo",
  error_file_format: "Añada un archivo en el formato correcto",
  error_date: "Introduzca una fecha de inicio anterior a la fecha de finalización",
  link: "Abrir el enlace",
  dateChoice: "Haga clic para elegir una fecha",
  next: "Siguiente",
  formTabPrevious: "Anterior",
  formTabNext: "Siguiente",
  pleaseWait: "Espere...",
  select: "Seleccionar",
  apply: "Aplicar",
  apply_to_selection: "Aplicar a la selección",
  cancel: "Cancelar",
  save: "Registrar",
  leave_without_save: "Salir sin guardar",
  leave_confirmation: "¿Está seguro de que desea cerrar sin guardar?",
  ok: "Aceptar",
  edit: "Modificar",
  synchronize: "Sincronizar",
  no: "No",
  yes: "Sí",
  warning: "Atención",
  iConfirm: "Confirmo",
  Save: "Almacenamiento",
  saveFinish: "Almacenamiento finalizado",
  fileFormatError: "Seleccione un archivo en el formato correcto",
  display: "Mostrar",
  elements: "elementos",
  lines: "Líneas",
  conditions: {
    title: "Condición de aplicación del modelo",
    info: "Para crear plantillas específicas, duplique la plantilla predeterminada y defina las condiciones de aplicación (pestaña 3)",
    alerte:
      "Por defecto, este modelo se aplica a todos los casos. Si define condiciones a continuación, el modelo solo se aplicará cuando se cumplan todas las condiciones (lógica Y).",
  },
  pagination: {
    to: "para",
    on: "en",
  },
  close: "Cerrar",
  overview: "Vista previa",
  regenerate: "Regenerar",
  captcha: {
    new_calculation: "Nuevo cálculo",
    reload_error: "No se pudo generar un nuevo cálculo, intenta de nuevo.",
  },
  option_value: "Valor",
  option_label: "Etiqueta",
  submit: "Enviar",
  submit_success: "¡Formulario enviado correctamente!",
  back: "Volver",
  remove: "Eliminar",
  typeYourSearch: "Escriba su búsqueda...",
  sortBy: "Ordenar por",
  order: "Orden",
  desc: "Descendente",
  asc: "Ascendente",
  reset: "Reiniciar",
  filter: "Filtrar",
  Search: "Buscar",
  "No data available in the table": "Ningún dato disponible en la tabla",
  "No data available": "Ningún dato disponible",
  "Please enter or modify your search": "Introduzca o modifique su búsqueda",
  "Please click on the add button": "Haga clic en el botón para añadir",
  search: "Buscar",
  All: "Todos",
  None: "Ninguno",
  choicesScrollLabel: "Lista de opciones, desplazable",
  "PDF export": "Exportar a PDF",
  "Excel export": "Exportar a Excel",
  "PNG export": "Exportar a PNG",
  "SVG export": "Exportar a SVG",
  "See statistics": "Ver las estadísticas",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Añadir un valor",
    select_option: "",
    no_result: "Ningún resultado coincide con la búsqueda",
    no_options: "Escriba por lo menos {nb} caracteres para buscar resultados...",
  },
  init_search: "Reinicializar la búsqueda",
  search_motor: "Buscador",
  file_size_error: "El archivo es demasiado grande, seleccione uno de menos de ",
  video_not_supported_mobile: "No es posible añadir un vídeo desde la aplicación móvil",
  maxTagError: "Respete el número máximo de valores",
  minTagError: "Respete el número mínimo de valores",
  see_more_fields: "Ver más campos",
  justificative_piece: "Justificantes",
  skillRecap: "Resumen de competencias",
  valid: "Valide",
  unlock: "Desbloquear",
  light: "Claro",
  dark: "Oscuro",
  system: "Sistema",
  extensions_accepted: "Seleccione un archivo de tipo pdf, doc, xls, xlsx, csv, docx, jpeg, svg, bmp, gif o png.",
  extensions_accepted_document_image: "Seleccione un archivo de tipo pdf, doc, docx, xls, xlsx, pptx, gif, jpeg o png.",
  tab_error: "Error en esta pestaña",
  tab_locked: "Pestaña bloqueada: rellene los campos obligatorios de las pestañas anteriores",
  tab_status_pending: "Pestaña pendiente",
  tab_status_in_progress: "Pestaña en curso",
  tab_status_completed: "Pestaña completada",
  regenerate_succes: "¡Identificador regenerado correctamente!",
  password_validation: {
    title: "Introduzca una contraseña que incluya:",
    condition1: "Una letra mayúscula",
    condition2: "Una letra minúscula",
    condition3: "Una cifra",
    condition4: "Un carácter especial",
    condition5: "Mínimo 12 caracteres",
  },
  dropzone: {
    release: "Suelta el archivos aquí para subirlo.",
    drop: "Depositar el archivos aquí o",
    click_here: "clic",
    to_upload: "para subir.",
    downloading: "Descarga en curso...",
    file: "Archivo",
    max_files: "Máximo {count} archivos",
    max_files_message: "Ya ha alcanzado el límite de archivos permitido.",
    max_file_size: "El tamaño del archivo {name} supera el límite permitido.",
    file_extension_error: "La extensión del archivo {name} no es válida.",
    error_title: "Atención: algunos archivos no han sido aceptados.",
    file_size_error: "El tamaño máximo por archivo es de {size} MB.",
    upload_timeout_error: "El envío del archivo tardó demasiado y fue interrumpido. Por favor, inténtelo de nuevo.",
  },
  upload_signed_document: {
    label: "Subir el documento firmado",
    one_file: "Debe subir al menos 1 archivo",
    file_only: "Seleccione un archivo PDF",
    overview: "Vista previa",
    close: "Cerrar",
    regenerate: "Regenerar",
    option_value: "Valor",
    option_label: "Etiqueta",
  },
  user_permissions: {
    archive_label: "Ver promociones anteriores",
    profile_label: "Ver todos los perfiles activos",
    search_label: "Buscar...",
    title: "Lista de perfiles del usuario",
    choose_profile: "Elige el perfil que deseas añadir",
  },
  form_error: {
    verify_fields:
      "Algunos campos del formulario contienen errores; por favor, compruébelos y vuelva a enviar el formulario.",
    minimum_value: "Valor mínimo: {value}",
    maximum_value: "Valor máximo: {value}",
  },
  editor: {
    image_upload_error: "Error al subir la imagen",
    image_read_error: "Error al leer la imagen",
    file_upload_error: "Error al subir el archivo",
    file_read_error: "Error al leer el archivo",
    insert_image: "Insertar imagen",
    image_size_title: "Tamaño de imagen",
    image_alt: "Texto alternativo",
    image_width: "Ancho",
    image_height: "Alto",
  },
  filePicker: {
    camera: "Cámara",
    files: "Archivos",
    pictures: "Fotos",
    clipboard_no_image: "El portapapeles no contiene una imagen",
    clipboard_unavailable: "No se puede acceder al portapapeles",
    permission_denied_camera: "El acceso a la cámara está denegado. Actívelo en los ajustes de su dispositivo.",
    permission_denied_photos: "El acceso a las fotos está denegado. Actívelo en los ajustes de su dispositivo.",
    error: "Se ha producido un error al recuperar el archivo",
  },
  slider: {
    start: "Inicio",
    in_progress: "En curso",
    end: "Terminado",
  },
  writing_assistant: {
    title: "Asistente de redacción",
    disable: "Desactivar el asistente",
    toggle_label: "Asistente IA",
    helpful: "Esta pregunta me ha ayudado",
    dismiss: "Ocultar esta pregunta",
    loading: "Generando preguntas…",
    unavailable: "El asistente no está disponible momentáneamente",
    questions_announce: "{count} pregunta del asistente | {count} preguntas del asistente",
    minutes: "{count} minuto | {count} minutos",
    minutes_short: "{count} min",
    paused: "Pausa en {field} · vuelve en {duration}",
    paused_many: "Pausa en {count} campos · próximo regreso en {duration}",
    paused_announce: "El asistente está en pausa en {fields}; vuelve en {duration}.",
    resumed_announce: "El asistente vuelve a estar disponible en {fields}.",
    field_quoted: "«{field}»",
    fields: {
      contexte: "Contexto",
      taches: "Tareas",
      difficultes: "Dificultades",
      resultats: "Resultados",
      apprentissages: "Aprendizajes",
      unknown: "este campo",
    },
    info: {
      aria_label: "¿Cómo funciona el asistente de IA?",
      title: "¿Cómo funciona?",
      purpose: "El asistente te hace preguntas para ayudarte a desarrollar tu texto.",
      triggers: "Se activa solo cuando tu texto alcanza {threshold} caracteres, tras una breve pausa al escribir.",
      limit:
        "Un máximo de {max} sugerencias por campo. Una vez usadas, el asistente vuelve a estar disponible en ese campo al cabo de {duration}.",
    },
  },
  date_error: {
    date_format_error: "El formato de la fecha es inválido",
    date_min_error: "La fecha debe ser estrictamente posterior al campo {fieldName}",
    date_max_error: "La fecha debe ser estrictamente anterior al campo {fieldName}",
  },
  number_error: {
    number_format_error: "El formato del número es inválido",
    number_min_error: "Este campo debe ser menor o igual al campo {fieldName}",
    number_max_error: "Este campo debe ser mayor o igual al campo {fieldName}",
  },
};
